export default {"src":"/_next/static/media/check-new.0d96966b.svg","height":38,"width":38,"blurWidth":0,"blurHeight":0};